import AllUserProfiles from './AllUserProfiles';

export default AllUserProfiles;
